import { render, staticRenderFns } from "./telzxhpls.vue?vue&type=template&id=be157d08&scoped=true&"
import script from "./telzxhpls.vue?vue&type=script&lang=js&"
export * from "./telzxhpls.vue?vue&type=script&lang=js&"
import style0 from "./telzxhpls.vue?vue&type=style&index=0&id=be157d08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be157d08",
  null
  
)

export default component.exports